import controller from './campaigns.controller';
import template from './campaigns.html';
import './campaigns.scss';
/**
 * @ngdoc component
 * @name campaigns
 * @description
 * The campaigns component of the app.
 *
 * @memberof campaigns
 */
export default {
  /**
   * The controller class for the component.
   * @type {CampaignsController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/campaigns/components/campaigns/campaigns.component.js